module.exports = __webpack_public_path__ + "static/DevOps-Iphone-Still-49177b0af73c4df5d778784e24fe5706.jpg";